import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import "./App.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import FeeReceiptUI from "./feeReciptUI";

const StudentFeeReceipt = () => {
  const { transaction_id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const admissionNumber = queryParams.get("admissionNumber");
  const navigate = useNavigate();
  const [receiptData, setReceiptData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const case_number = sessionStorage.getItem("feeToken");

  const fetchReceiptData = useCallback(async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/ladyirwin-api/getFeeReceipt/${transaction_id}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ admissionNumber }), // ✅ Wrap in object
        }
      );

      const result = await response.json();

      if (result.length > 0) {
        setReceiptData(result[0]);
      } else {
        setReceiptData(null);
      }
    } catch (error) {
      console.error("Error fetching receipt data:", error);
    } finally {
      setIsLoading(false);
    }
  }, [transaction_id, admissionNumber]); // ✅ Include admissionNumber in deps

  // Fetch data when the component mounts
  useEffect(() => {
    if (!case_number) {
      // Redirect to login page if studentId is missing
      navigate("/ladyirwin");
    } else {
      fetchReceiptData();
    }
  }, [case_number, fetchReceiptData, navigate]);

  const sendEReceipt = async (receiptData) => {
    const receiptElement = document.querySelector(".receipt-container");
    if (!receiptElement) {
      console.error("Receipt container not found.");
      return;
    }

    try {
      const canvas = await html2canvas(receiptElement, {
        scale: 2,
        useCORS: true,
      });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const ratio = Math.min(
        pdf.internal.pageSize.getWidth() / canvas.width,
        pdf.internal.pageSize.getHeight() / canvas.height
      );

      pdf.addImage(
        imgData,
        "PNG",
        0,
        0,
        canvas.width * ratio,
        canvas.height * ratio
      );
      const pdfBlob = pdf.output("blob");

      const formData = new FormData();
      formData.append(
        "file",
        pdfBlob,
        `${receiptData.transaction_id}_Receipt.pdf`
      );
      formData.append("name", receiptData.studentName);
      formData.append("email", receiptData.email);
      formData.append("transaction_id", receiptData.transaction_id);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/ladyirwin-api/send-receipt`,
        { method: "POST", body: formData }
      );

      if (!response.ok) {
        throw new Error(
          `Receipt submission failed! Status: ${response.status}`
        );
      }
    } catch (error) {
      console.error("Error sending receipt:", error);
    }
  };

  return (
    <div>
      <FeeReceiptUI
        receiptData={receiptData}
        isLoading={isLoading}
        sendEReceipt={sendEReceipt} // Properly integrated function
      />
    </div>
  );
};

export default StudentFeeReceipt;

